export const formRow = "d-flex gap-3";
export const buttonStyle = "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center rounded";
export const selected = "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center rounded";
